// src/components/navbar/hooks/useNavbarAppearance.js

import { useEffect, useMemo, useState } from "react";
import { getDocumentScrollTop } from "../utils/navbarUtils";
import { NAVBAR_CONFIG } from "../data/navbarTheme";

export default function useNavbarAppearance({
  pathname,
  forceSolid = false,
}) {
  const [isScrolled, setIsScrolled] = useState(() => {
    return getDocumentScrollTop() > NAVBAR_CONFIG.scrollThreshold;
  });

  useEffect(() => {
    let animationFrameId = null;

    const updateScrollState = () => {
      const scrollTop = getDocumentScrollTop();

      setIsScrolled(scrollTop > NAVBAR_CONFIG.scrollThreshold);
    };

    const handleScroll = () => {
      if (animationFrameId) return;

      animationFrameId = window.requestAnimationFrame(() => {
        updateScrollState();
        animationFrameId = null;
      });
    };

    updateScrollState();

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);

      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  const isHomePage = pathname === "/";

  const isTransparent = useMemo(() => {
    return isHomePage && !isScrolled && !forceSolid;
  }, [forceSolid, isHomePage, isScrolled]);

  return {
    isHomePage,
    isScrolled,
    isTransparent,
  };
}